import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";

import { ROUTE_TITLE, redirectFor, routeOf } from "./routes";
import { HomePage } from "./ui/Home";
// MapLibre's stylesheet MUST load before ours: our map-container rules beat
// its `.maplibregl-map { position: relative }` only by coming later in the
// cascade. Imported here, in the entry, rather than in the lazy App chunk —
// when it rode along with App its CSS landed after styles.css and the map
// container collapsed to zero height in production (2026-09-05).
import "maplibre-gl/dist/maplibre-gl.css";
import "./styles.css";
import "./ui/radar.css";

// The old top-level URLs move under /front-range with their query intact
// (routes.ts). Nothing renders on a redirecting page.
const moved = redirectFor(window.location.pathname, window.location.search, window.location.hash);
if (moved) window.location.replace(moved);

// The project home is prose, one card and a form: it must not pay for the
// map engine or the twin's data fetches. Everything else lives in App, which
// arrives as its own chunk on the Front Range routes.
const App = lazy(() => import("./App"));
const route = routeOf(window.location.pathname);

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

if (!moved) {
  document.title = ROUTE_TITLE[route];
  createRoot(root).render(
    <StrictMode>
      {route === "home" ? (
        <HomePage />
      ) : (
        <Suspense fallback={null}>
          <App />
        </Suspense>
      )}
    </StrictMode>,
  );
}
